import { render, staticRenderFns } from "./DocumentosImportacionTable.vue?vue&type=template&id=02d3e1df&scoped=true"
import script from "./DocumentosImportacionTable.vue?vue&type=script&lang=ts"
export * from "./DocumentosImportacionTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentosImportacionTable.vue?vue&type=style&index=0&id=02d3e1df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3e1df",
  null
  
)

export default component.exports